/**
* Timeline Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Timeline Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {MotionPathPlugin} from 'gsap/MotionPathPlugin.js';
import {DrawSVGPlugin} from 'gsap/DrawSVGPlugin.js';

( function( app ) {
  const COMPONENT = {

    className: 'timeline-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger, MotionPathPlugin, DrawSVGPlugin );

      gsap.utils.toArray( '.timeline-left-right' ).forEach( ( section ) => {
        const path = section.querySelector( 'svg .motionPath' );
        const main = gsap.timeline( {defaults: {duration: 1},
          scrollTrigger: {
            trigger: section,
            scrub: true,
            start: 'top center',
            end: 'bottom center',
            toggleClass: 'active-path',
            ease: 'none',
          }} )
            .to( '.circle', {duration: 0.01, autoAlpha: 1} )
            .from( path, {drawSVG: 1}, 1 )
            .to( '.circle', {
              duration: 100,
              motionPath: {
                path: path,
                align: path,
                alignOrigin: [0.5, 0.5],
              }}, 0 );
      } );


      gsap.utils.toArray( '.red-border' ).forEach( ( redBorder ) => {
        gsap.to( redBorder, {
          scrollTrigger: {
            trigger: redBorder,
            start: 'top 60%',
            end: 'bottom 40%',
            toggleClass: 'active',
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'timeline-left-right', COMPONENT );
} )( app );
